import React, { lazy, useEffect } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { setNavigate } from '../../utility/navigateHandler';
import RaporLayout from '../../container/raporDogrula/Index';

// const NotFound = lazy(() => import('../container/pages/404'));
const RaporDogrula = lazy(() => import('../../container/raporDogrula/RaporDogrula'));

const ProjeRoot = () => {
  const navigate = useNavigate();

  <div> </div>;

  useEffect(() => navigate('/'));
};

const FrontendRoutes = React.memo(() => {
  const navigate = useNavigate();
  useEffect(() => {
    setNavigate(navigate);
  }, [navigate]);

  return (
    <Routes>
      <Route path="raporDogrula" element={<RaporDogrula />} />
      {/* <Route index element={<Login />} />
      <Route path="forgotPassword" element={<ForgotPass />} />
      <Route path="register" element={<SignUp />} />
      <Route path="fbRegister" element={<FbSignUp />} />
      <Route path="fbSignIn" element={<FbLogin />} /> */}
      {/* <Route path="*" element={<NotFound />} /> */}
      <Route path="*" element={<ProjeRoot />} />
    </Routes>
  );
});

export default RaporLayout(FrontendRoutes);
